module.exports = __webpack_public_path__ + "assets/img/mailIcon.eebddb14.svg";